import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  headingTitle: {
    id: 'views.Management.heading.title',
    defaultMessage: 'Władze spółki:'
  },
  headingManagement: {
    id: 'views.CompanyResults.heading.management',
    defaultMessage: 'Zarząd'
  },
  headingDirectors: {
    id: 'views.CompanyResults.heading.directors',
    defaultMessage: 'Rada nadzorcza'
  },
  headingShareholders: {
    id: 'views.CompanyResults.heading.shareholders',
    defaultMessage: 'Akcjonariat'
  }
});



// WEBPACK FOOTER //
// ./src/views/Home/Sections/Management/Management.intl.js